import IncomeCertificate from '@/components/molecules/income-certificate/incomeCertificate';

import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';
import './incomeStatementCertificateContent.scss';

const IncomeStatementCertificateContent = ({ contentInfo }: any) => {
  return (
    <div className="o-income_statement_certificate_content">
      <Breadcrumb content={contentInfo.migaDePan} />
      <div className="o-income_statement_certificate_content__headings">
        {contentInfo && contentInfo.nombre && (
          <h1 className="o-income_statement_certificate_content__headings__title">
            {contentInfo.nombre}
          </h1>
        )}
        {contentInfo && contentInfo.subtitulo && (
          <p className="o-income_statement_certificate_content__headings__subtitle">
            {contentInfo.subtitulo}
          </p>
        )}
      </div>
      <IncomeCertificate
        contentInfo={contentInfo.referencias}
        note={contentInfo.descripcion}
        imagen={contentInfo.imagen}
      />
    </div>
  );
};

export default IncomeStatementCertificateContent;
